import { NavLink } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const STAGE_LABELS = { professional: "Professional", student: "Student", pivot: "Pivot" };
const formatInterviewDate = (value) => value
  ? new Intl.DateTimeFormat(undefined, { day: "numeric", month: "short", year: "numeric" }).format(new Date(value))
  : "";

export default function InterviewList({ interviews }) {
  if (!interviews.length)
    return <div className="empty-state" data-testid="empty-interviews-state">No interviews yet. Start your first one above.</div>;

  return (
    <div className="interview-list" data-testid="interview-list">
      {interviews.map((item) => (
        <NavLink className="interview-row" to={`/interview/${item.id}`} key={item.id} data-testid={`interview-row-${item.id}`}>
          <div>
            <strong data-testid={`interview-title-${item.id}`}>{item.title}</strong>
            <span data-testid={`interview-date-${item.id}`}>{formatInterviewDate(item.updated_at)}</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: ".5rem", flexShrink: 0 }}>
            {item.interview_type && (
              <span className="stage-pill" data-testid={`interview-type-${item.id}`}>
                {STAGE_LABELS[item.interview_type] ?? item.interview_type}
              </span>
            )}
            <span className={`status-pill ${item.status}`} data-testid={`interview-status-${item.id}`}>
              {item.status === "active" ? "In progress" : "Complete"}
            </span>
          </div>
          <ChevronRight size={18} />
        </NavLink>
      ))}
    </div>
  );
}
